import { Key } from "react";
import { useAddRemoveProduct } from "../../hooks/hoops/useAddRemoveProduct";
import { Button, DeleteIcon } from "melco-ui";
import { useTranslation } from "react-i18next";

export type BulkActionRemoveHoopProductsProps = {
    selectedRowKeys: Key[];
    setSelectedRowKeys: (keys: Key[]) => void
    refecth?: () => Promise<any>;
    data?: any[];
}

export const BulkActionRemoveHoopProducts: React.FC<BulkActionRemoveHoopProductsProps> = ({
    selectedRowKeys,
    setSelectedRowKeys
}) => {
    const { removeProducts } = useAddRemoveProduct();

    const { t } = useTranslation();

    const idsToRemove = selectedRowKeys.map((srk) => {
        return {
            "product_code": srk as string
        }
    })
    return (<>
        {
            selectedRowKeys.length > 0 &&
            <Button
                icon={<DeleteIcon />}
                onClick={() => {
                    removeProducts(idsToRemove);
                    setSelectedRowKeys([]);
                }}
            >
                {t('managehoops.tabs.products.button.remove')}           </Button>
        }

    </>)
}